import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
   path: '',
  component: LoginPageComponent,
  children: [
    { path: '', component: LoginPageComponent },
  ],
},
 {
   path: 'loginSSO',
  component: LoginComponent,
 
}
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class loginRoutingModule { }
